import {Button, ButtonProps, Lead, Typography} from '@logistics-frontend/blocks'
import React, {PropsWithChildren} from 'react'

import * as classes from './ActionButton.classes'

type Props = PropsWithChildren<{
  title: string
  variant?: ButtonProps['variant']
  onPress?: ButtonProps['onPress']
  loading?: ButtonProps['loading']
  badge?: React.ReactNode
  lead?: React.ReactNode
  disabled?: ButtonProps['disabled']
}>

export function ActionButton(props: Props) {
  const {title, lead, children, variant = 'default', onPress, loading, badge, disabled} = props

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        disabled={disabled}
        loading={loading}
        onPress={onPress}
        shape="circle"
        size="l"
        variant={variant}
      >
        {lead ? <Lead>{lead}</Lead> : children}
      </Button>
      <Typography color="minor" justifyContent="center" mt="s" variant="caption1">
        {title.replace(/ /g, '\r\n')}
      </Typography>
      {badge}
    </div>
  )
}
